import React from "react";
import styled from "styled-components";
import {subduedTextColour, timelineColour} from "../../../../style/styleConsts";
import {useSelector} from "react-redux";
import {Clock} from "js-joda";
import {activityTime} from "./activityTime";

const TopRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
`;

const Age = styled.span`
    color: ${subduedTextColour};
    font-weight: bold;
`;

const Action = styled.div`
    background-color: ${timelineColour};
    color: ${subduedTextColour};
    font-weight: bold;
    padding: 1px 6px;
    border-radius: 5px;
    text-align: center;
`;

export const ActivityTopRow = ({name, dateTime}) => {
    const clock = useSelector(({clock}) => clock || Clock.systemDefaultZone());
    return <TopRow>
        <Action>{name}</Action>
        <Age>{activityTime(dateTime, clock)}</Age>
    </TopRow>;
}